import template from './messageList.html';

let component = {
  restrict: 'E',
  template,
  controllerAs: 'vm',
  bindings: {
    messages: '<',
  },
};

export default component;
